// extracted by mini-css-extract-plugin
export default {"content":"layout_content__-L5Bc","extraSpace":"layout_extraSpace__beCn9"};